import React, { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { Pagination } from 'rsuite';
import { Link } from 'react-router-dom';
import ls from 'localstorage-slim';
import axios from 'axios';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import { refreshToken, getETAToken, updateUserLastLogin } from '../helpers';
import Loading from '../GeneralComponents/Loading';

function Code() {
  const [codes, setCodes] = useState([]);
  const [metaData, setMetaData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [activePage, setActivePage] = useState(1);

  const subDomain = ls.get('subDomain');

  const { t, i18n } = useTranslation();

  useEffect(() => {
    async function fetchData() {
      const codeToast = toast.loading('Please wait...');
      try {
        if (!ls.get('access')) {
          await refreshToken();
          await updateUserLastLogin();
        }
        if (!ls.get('ETAToken')) await getETAToken();

        let response = await axios.get(
          `${subDomain}${process.env.REACT_APP_DJANGO_BASEURL}/erp/published_codes`,
          {
            params: {
              accessToken: ls.get('ETAToken'),
              pageNumber: activePage,
              codeType: 'EGS',
              taxpayer: ls.get('taxpayer_id'),
            },
          }
        );

        setCodes(response.data.result);
        setMetaData(response.data.metadata);
        setIsLoading(false);

        toast.update(codeToast, {
          render: 'Codes retrieved successfully',
          type: 'success',
          isLoading: false,
          autoClose: 1000,
          theme: 'colored',
        });
      } catch (error) {
        if (error.response) {
          // Request made but the server responded with an error
          console.log(error.response.data);
          toast.update(codeToast, {
            render: `${error.response.data}`,
            type: 'error',
            isLoading: false,
            autoClose: 1000,
            theme: 'colored',
          });
        } else if (error.request) {
          // Request made but no response is received from the server.
          console.log(error.request);
          toast.update(codeToast, {
            render: `${error.request}`,
            type: 'error',
            isLoading: false,
            autoClose: 1000,
            theme: 'colored',
          });
        } else {
          // Error occured while setting up the request
          console.log('Error', error.message);
          toast.update(codeToast, {
            render: `${error.message}`,
            type: 'error',
            isLoading: false,
            autoClose: 1000,
            theme: 'colored',
          });
        }
      }
    }

    fetchData();
  }, [activePage]);

  return isLoading ? (
    <Loading />
  ) : (
    <>
      <div className='container-fluid'>
        <div className='shadow m-3 p-2'>
          <div
            className={`row ${
              i18n.language === 'en' ? 'justify-content-start' : 'justify-content-end'
            } my-3 mx-2`}>
            <span
              className={`${
                i18n.language === 'en' ? 'me-5' : 'ms-5'
              } col-2 fs-4 text-decoration-underline`}
              style={{ textUnderlineOffset: '10px' }}>
              <span>{t('code.title')}</span>
            </span>
          </div>
          <div className='row justify-content-center mx-2 text-center'>
            <table className='table col mt-2' dir={`${i18n.language === 'ar' && 'rtl'}`}>
              <thead
                style={{
                  verticalAlign: 'middle',
                }}>
                <tr>
                  <th scope='col'>{t('code.table.type')}</th>
                  <th scope='col'>{t('code.table.unique')}</th>
                  <th scope='col' className='text-nowrap'>
                    {t('code.table.name')}
                  </th>
                  <th scope='col'>{t('code.table.description')}</th>
                  <th scope='col'>{t('code.table.requestedBy')}</th>
                  <th scope='col' className='text-nowrap'>
                    {t('code.table.activeFrom')}
                  </th>
                  <th scope='col' className='text-nowrap'>
                    {t('code.table.activeTo')}
                  </th>
                  <th scope='col' dir='ltr'>
                    {t('code.table.active')}
                  </th>
                </tr>
              </thead>
              <tbody>
                {codes.map(code => (
                  <tr key={code.codeID}>
                    <th scope='row'>
                      <div className='py-3'>{code.codeTypeNamePrimaryLang}</div>
                    </th>
                    <td className='text-nowrap'>
                      <div className='py-3'>
                        <Link
                          to={`../codes/${code.codeLookupValue}/${code.codeTypeNamePrimaryLang}`}>
                          {code.codeLookupValue}
                        </Link>
                      </div>
                    </td>
                    <td>
                      <div className='py-3'>{code.codeNamePrimaryLang}</div>
                    </td>
                    <td>
                      <div className='py-3'>{code.codeDescriptionPrimaryLang}</div>
                    </td>
                    <td className='text-nowrap'>
                      <div className='py-3'>{code.ownerTaxpayer.name}</div>
                    </td>
                    <td>
                      <div className='py-3'>{moment(code.activeFrom).format('DD/MM/YYYY')}</div>
                    </td>
                    <td>{code.activeTo}</td>
                    <td>
                      <div className='py-3'>{code.active ? 'Yes' : 'No'}</div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {codes.length === 0 && (
              <div className='d-flex justify-content-center'>
                <span>{t('document.table.noRecords')}</span>
              </div>
            )}
            <Pagination
              prev
              next
              total={metaData['totalCount']}
              limit={10}
              activePage={activePage}
              onChangePage={setActivePage}
              className='my-2 justify-content-center'
              size='md'
            />
          </div>
        </div>
      </div>
    </>
  );
}

export default Code;
